require('./dist/angular-filter.js');
module.exports = 'angular.filter';



//////////////////
// WEBPACK FOOTER
// ./~/angular-filter/index.js
// module id = 1497
// module chunks = 1